export const environment = {
  api: import.meta.env.VITE_API_URL || '',
  googlePublicCaptchaKey: import.meta.env.VITE_GOOGLE_CAPTCHA_KEY || '',
  maxTabs: parseInt(import.meta.env.VITE_MAX_TABS || '10', 10),
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || '',
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || '',
  encryptionKey: import.meta.env.VITE_ENCRYPTION_KEY || '',
  staleTime: parseInt(import.meta.env.VITE_STALE_TIME || '180000', 10) // Default 3 minutes in milliseconds
};
